import { service } from '@/common/request/request.js'

// 询直属列表
export function belongList(data = {}) {
  return service({
    url: '/userPromote/queryBelongList',
    method: 'post',
    data
  })
}

// 查询直属成员总数
export function BelongTotalInfo(data = {}) {
  return service({
    url: '/userPromote/queryBelongTotalInfo',
    method: 'post',
    data
  })
}

// 查询每日业绩
export function dailyPromote(data = {}) {
  return service({
    url: '/userPromote/queryDailyPromoteList',
    method: 'post',
    data
  })
}

// 查询我的业绩信息
export function myPromoteInfo(data = {}) {
  return service({
    url: '/userPromote/queryMyDailyPromoteInfo',
    method: 'post',
    data
  })
}

// 查询我的佣金派发记录
export function myPromoteRecord(data = {}) {
  return service({
    url: '/userPromote/queryMyPromoteGiftLogList',
    method: 'post',
    data
  })
}

// 查询我的团队信息
export function myTeamInfo(data = {}) {
  return service({
    url: '/userPromote/queryMyTeamInfo',
    method: 'post',
    data
  })
}

// 查询业绩推广等级
export function promoteLevel(data = {}) {
  return service({
    url: '/userPromote/queryPromoteLevelList',
    method: 'post',
    data
  })
}

// 查询团队列表
export function teamList(data = {}) {
  return service({
    url: '/userPromote/queryTeamList',
    method: 'post',
    data
  })
}

// 查询团队成员总数
export function teamTotalInfo(data = {}) {
  return service({
    url: '/userPromote/queryTeamTotalInfo',
    method: 'post',
    data
  })
}

// 提取我的佣金
export function drawMyPromote(data = {}) {
  return service({
    url: '/userPromote/withdrawMyPromoteAmount',
    method: 'post',
    data
  })
}


// 查询我的团队总数据
export function teamTotalData(data = {}) {
  return service({
    url: '/loged/teamTotalData',
    method: 'post',
    data
  })
}

// 新模式代理，首页待申请佣金，总佣金，总团队人数,统一下级佣金比例(如果这个值为空，或者里面的createAdmin字段不等于会员自己，则可以修改)
export function indexInfoNewAgent(data = {}) {
  return service({
    url: '/loged/indexInfoNewAgent',
    method: 'post',
    data
  })
}

//新模式代理，申请佣金到账
export function applyCommission(data = {}) {
  return service({
    url: '/loged/applyCommission',
    method: 'post',
    data
  })
}

//新模式代理，新模式代理，修改统一下级代理佣金   一 二级代理
export function updateSubSet(data = {}) {
  return service({
    url: '/loged/updateSubSet',
    method: 'post',
    data
  })
}


// 好友管理
export function friendsManagement(data = {}) {
  return service({
    url: '/loged/friendsManagement',
    method: 'post',
    data
  })
}

// 佣金列表   
// commissionStatus   '0:待审核,1:审核成功/待申请,2:申请中,3发放成功,4拒绝',
// commission_type    '-1,' 总计，0正常记录每月一次',
export function commissionRewards(data = {}) {
  return service({
    url: '/loged/commissionRewards',
    method: 'post',
    data
  })
}

// 新模式代理，会员注册成代理
export function registeredNewAgent(data = {}) {
  return service({
    url: '/loged/registeredNewAgent',
    method: 'post',
    data
  })
}

// 新模式代理，非会员注册成代理
export function registeredNewAgent_(data = {}) {
  return service({
    url: '/guest/registeredNewAgent',
    method: 'post',
    data
  })
}

// inviteInfo
export function inviteInfo(data = {}) {
  return service({
    url: '/loged/inviteInfo',
    method: 'post',
    data
  })
}

// 获取FAQ
export function indexInfoNewAgentFAQ(data = {}) {
  return service({
    url: '/guest/indexInfoNewAgent',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/common/api/team.js